<template>
    <GeneralDashboardLayout>
        <template v-slot:header>
            <div class="header-template">
                <BackButton :to="{ name: 'event-games.index' }" />
                <h1 class="title text-center">Event Trivia Game</h1>
                <span>
                    <button class="btn btn-outline-primary" @click="createClick" v-if="isTriviaNew">Create New</button>
                   
                </span>
            </div>
        </template>
        
        <template v-slot:content>
            <div class="trivia-container">
                <!-- Tabs Navigation -->
                <ul class="nav nav-tabs nav-justified mb-4">
                    <li class="nav-item">
                        <a class="nav-link" :class="{ active: activeTab === 'setup' }" 
                           @click="activeTab = 'setup'" href="javascript:void(0)">
                            <i class="fas fa-cog"></i> Trivia Setup
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" :class="{ active: activeTab === 'questions' }" 
                           @click="activeTab = 'questions'" href="javascript:void(0)" 
                           v-if="!isTriviaNew && triviaitems && triviaitems._id">
                            <i class="fas fa-question-circle"></i> Questions
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" :class="{ active: activeTab === 'results' }" 
                           @click="activeTab = 'results'; loadLeaderboard()" href="javascript:void(0)"
                           v-if="!isTriviaNew && triviaitems && triviaitems._id">
                            <i class="fas fa-chart-line"></i> Results & Leaderboard
                        </a>
                    </li>
                </ul>

                <!-- Tab Content: Trivia Setup -->
                <div v-show="activeTab === 'setup'">
                    <div class="trivia-details">
                        <div class="card">
                            <div class="card-header">
                                <h5>Trivia Details</h5>
                            </div>
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-12 mb-3">
                                        <label>Trivia Title *</label>
                                        <input type="text" class="form-control" 
                                               v-model="formData.title" 
                                               placeholder="Enter trivia title" />
                                        <div v-if="titleError" class="text-danger mt-1">
                                            {{ titleError }}
                                        </div>
                                    </div>

                                    <div class="col-md-6 mb-3">
                                        <label>Time Limit (seconds)</label>
                                        <input disabled type="number" class="form-control" 
                                               v-model="formData.timeLimit" 
                                               min="10" 
                                               max="300" />
                                    </div>

                                    <!--
                                    <div class="col-md-6 mb-3">
                                        <label>Make Results Public?</label>
                                        <br />
                                        <div class="switch switch-sm switch-primary">
                                            <input-switch name="is_open" 
                                                          :value="formData.isOpen" 
                                                          @change="updateIsOpen" />
                                        </div>
                                    </div>
                                    -->

                                    <div class="col-md-12 text-right">
                                        <button v-if="isTriviaNew" type="button" class="btn btn-primary" 
                                                @click="createTrivia" :disabled="loading">
                                            <i class="fas fa-save"></i> Create Trivia
                                        </button>
                                        <button v-else type="button" class="btn btn-primary" 
                                                @click="updateTrivia" :disabled="loading">
                                            <i class="fas fa-save"></i> Update Trivia
                                        </button>
                                        <button v-if="!isTriviaNew" type="button" class="btn btn-danger ms-2" 
                                                @click="deleteTrivia">
                                            <i class="fas fa-trash"></i> Delete Trivia
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Tab Content: Questions -->
                <div v-show="activeTab === 'questions'">
                    <div class="questions-section">
                        <div class="card">
                            <div class="card-header d-flex justify-content-between align-items-center">
                                <h5>Trivia Questions</h5>
                                <button class="btn btn-success btn-sm" @click="openAddQuestionModal">
                                    <i class="fas fa-plus"></i> Add Question
                                </button>
                            </div>
                            <div class="card-body">
                                <!-- Questions List -->
                                <div v-if="triviaitems.questions_detail && triviaitems.questions_detail.length > 0">
                                    <div class="table-responsive">
                                        <table class="table table-hover">
                                            <thead>
                                                <tr>
                                                    <th width="50">#</th>
                                                    <th>Question</th>
                                                    <th>Answer Options</th>
                                                    <th width="150">Correct Answer</th>
                                                    <th width="80">Required</th>
                                                    <th width="100">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(question, index) in triviaitems.questions_detail" :key="question._id">
                                                    <td>{{ index + 1 }}</td>
                                                    <td class="question-text">{{ question.question_title }}</td>
                                                    <td>
                                                        <ul class="answer-list">
                                                            <li v-for="(ans, idx) in question.answers" :key="ans._id">
                                                                {{ String.fromCharCode(65 + idx) }}. {{ ans.answer_title }}
                                                            </li>
                                                        </ul>
                                                    </td>
                                                    <td>
                                                        <span class="badge bg-success">
                                                            {{ getCorrectAnswerText(question) }}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span :class="question.require ? 'badge bg-primary' : 'badge bg-secondary'">
                                                            {{ question.require ? 'Required' : 'Optional' }}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <button class="btn btn-sm btn-primary me-1" @click="editQuestion(question)">
                                                        <i class="fas fa-edit"></i>
                                                        </button>
                                                        <button class="btn btn-sm btn-danger" @click="deleteQuestion(question._id)">
                                                            <i class="fas fa-trash"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div v-else class="text-center text-muted p-5">
                                    <i class="fas fa-question-circle fa-3x mb-3"></i>
                                    <p>No questions added yet. Click "Add Question" to create trivia questions.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Tab Content: Results & Leaderboard -->
                <div v-show="activeTab === 'results'">
                    <div class="results-section">
                        <!-- Statistics Cards -->
                       <!-- Statistics Cards -->
                        <div class="row mb-4">
                            <div class="col-md-3">
                                <div class="card stat-card">
                                    <div class="card-body text-center">
                                        <i class="fas fa-users fa-2x text-primary mb-2"></i>
                                        <h3>{{ statistics.total_participants || 0 }}</h3>
                                        <p class="text-muted mb-0">Total Participants</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="card stat-card">
                                    <div class="card-body text-center">
                                        <i class="fas fa-chart-line fa-2x text-success mb-2"></i>
                                        <h3>{{ statistics.average_score || 0 }}%</h3>
                                        <p class="text-muted mb-0">Average Score</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="card stat-card">
                                    <div class="card-body text-center">
                                        <i class="fas fa-trophy fa-2x text-warning mb-2"></i>
                                        <h3>{{ statistics.highest_score || 0 }}%</h3>
                                        <p class="text-muted mb-0">Highest Score</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="card stat-card">
                                    <div class="card-body text-center">
                                        <i class="fas fa-question-circle fa-2x text-info mb-2"></i>
                                        <h3>{{ statistics.total_questions || 0 }}</h3>
                                        <p class="text-muted mb-0">Total Questions</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Leaderboard Table -->
                        <div class="card">
                            <div class="card-header">
                                <h5>Leaderboard</h5>
                                <div class="float-right">
                                    <select v-model="leaderboardLimit" @change="loadLeaderboard" class="form-control form-control-sm" style="width: auto;">
                                        <option value="10">Top 10</option>
                                        <option value="20">Top 20</option>
                                        <option value="50">Top 50</option>
                                        <option value="100">Top 100</option>
                                    </select>
                                </div>
                            </div>
                            <div class="card-body">
                                <div v-if="leaderboardLoading" class="text-center p-5">
                                    <div class="spinner-border text-primary" role="status">
                                        <span class="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                                <div v-else-if="leaderboardData.length === 0" class="text-center text-muted p-5">
                                    <i class="fas fa-chart-line fa-3x mb-3"></i>
                                    <p>No scores submitted yet. Participants will appear here once they complete the trivia.</p>
                                </div>
                                <div v-else class="table-responsive">
                                    <table class="table table-hover leaderboard-table">
                                        <thead>
                                            <tr>
                                                <th width="80">Rank</th>
                                                <th>Participant</th>
                                                <th width="150">Score</th>
                                                <!--
                                                <th width="150">Correct Answers</th>
                                                <th width="150">Total Questions</th>
                                                <th width="150">Accuracy</th>
                                                -->
                                                <th width="180">Submitted At</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(score, index) in leaderboardData" :key="score._id" 
                                                :class="{ 'top-rank': index < 3 }">
                                                <td>
                                                    <span class="rank-badge" :class="getRankClass(index)">
                                                        {{ index + 1 }}
                                                        <i v-if="index === 0" class="fas fa-crown text-warning"></i>
                                                    </span>
                                                </td>
                                                <td>
                                                    <div class="user-info">
                                                        <strong>{{ score.user_name || 'Anonymous' }}</strong>
                                                        <small class="text-muted d-block">{{ score.user_email }}</small>
                                                    </div>
                                                </td>
                                                <td>
                                                        <div class="score-bar">
                                                            <div class="progress" style="height: 30px;">
                                                                <div class="progress-bar" 
                                                                    :class="getScoreClass(score.score)"
                                                                    :style="{ width: score.score + '%' }">
                                                                    {{ score.score }}%
                                                                </div>
                                                            </div>
                                                            <small class="text-muted" v-if="score.raw_score !== undefined">
                                                                ({{ score.raw_score }}/{{ score.total_questions }} correct)
                                                            </small>
                                                        </div>
                                                    </td>
                                                <!--
                                                <td>
                                                    <span class="badge bg-success">
                                                        {{ score.correct_answers || 0 }}
                                                    </span>
                                                </td>
                                                -->
                                                  <!--
                                                <td>
                                                    <span class="badge bg-info">
                                                        {{ score.total_questions || 0 }}
                                                    </span>
                                                </td>
                                            -->
                                                <!--
                                                <td>
                                                    <span class="badge" :class="getAccuracyClass(score.accuracy)">
                                                        {{ score.accuracy || 0 }}%
                                                    </span>
                                                </td>
                                                -->
                                                <td>
                                                    <small>{{ formatDate(score.submitted_at) }}</small>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <!-- Export Button -->
                         <!--
                        <div class="mt-3 text-right">
                            <button class="btn btn-secondary" @click="exportLeaderboard">
                                <i class="fas fa-download"></i> Export Leaderboard (CSV)
                            </button>
                        </div>
                        -->
                    </div>
                </div>
            </div>

            <!-- Add/Edit Question Modal -->
            <div class="modal fade" id="questionModal" tabindex="-1" data-bs-backdrop="static">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">{{ isEditingQuestion ? 'Edit Question' : 'Add New Question' }}</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md-12 mb-3">
                                    <label>Question *</label>
                                    <textarea class="form-control wrap-text"
                                        rows="2"
                                        v-model="questionForm.question_title"
                                        placeholder="Enter your question">
                                    </textarea>


                                   
                                    <div v-if="questionError" class="text-danger mt-1">
                                        {{ questionError }}
                                    </div>
                                </div>

                                <div class="col-md-12 mb-3">
                                    <label>Answer Options</label>
                                    <div v-for="(answer, idx) in questionForm.answers" :key="answer.tempId" 
                                         class="answer-option mb-2">
                                        <div class="row align-items-center">
                                            <div class="col-md-8">
                                                <div class="input-group">
                                                    <span class="input-group-text">{{ String.fromCharCode(65 + idx) }}</span>
                                                    <textarea class="form-control wrap-text"
          rows="1"
          v-model="answer.answer_title"
          :placeholder="`Option ${String.fromCharCode(65 + idx)}`"></textarea>
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div class="form-check">
                                                    <input type="radio" class="form-check-input" 
                                                           :name="'correct_answer'"
                                                           :value="idx"
                                                           v-model="questionForm.correctAnswerIndex" />
                                                    <label class="form-check-label">Correct Answer</label>
                                                </div>
                                            </div>
                                            <div class="col-md-1">
                                                <button type="button" class="btn btn-danger btn-sm" 
                                                        @click="removeAnswer(idx)" v-if="questionForm.answers.length > 2">
                                                    <i class="fas fa-trash"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <!--
                                    <button type="button" class="btn btn-secondary btn-sm mt-2" @click="addAnswer">
                                        <i class="fas fa-plus"></i> Add Option
                                    </button>
                                    -->
                                    <small class="text-muted d-block mt-2">Minimum 4 options required</small>
                                </div>

                                <div class="col-md-12 mb-3">
                                    <div class="form-check">
                                        <input type="checkbox" class="form-check-input" 
                                               id="requireQuestion"
                                               v-model="questionForm.require" />
                                        <label class="form-check-label" for="requireQuestion">
                                            Required question
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <div class="d-flex gap-2 justify-content-end w-100">
                                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="resetFormAfterEdit">
                                    Cancel
                                </button>
                                <button type="button" class="btn btn-primary" @click="saveQuestion" :disabled="saving">
                                    <i class="fas fa-save"></i> {{ isEditingQuestion ? 'Update Question' : 'Save Question' }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <FlashMessage group="trivia_index" />
        </template>
    </GeneralDashboardLayout>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';
import { mapGetters, mapActions } from 'vuex';
import { Modal } from 'bootstrap';
import axios from "axios";
import constants from "@/config/constants";

import InputSwitch from "@/components/Commons/InputSwitch";
import BackButton from "@/components/Commons/BackButton";
import GeneralDashboardLayout from "@/components/layouts/GeneralDashboardLayout";
import { gettingErrorMessage } from "@/services/GetValidationMessage";

export default {
    name: 'TriviaIndex',
    components: {
        BackButton,
        GeneralDashboardLayout,
       // InputSwitch,
    },
    data() {
        return {
            eventId: null,
            activeTab: 'setup',
            formData: {
                title: '',
                timeLimit: 30,
                isOpen: false
            },
            titleError: '',
            questionError: '',
            showTriviaForm: true,
            loading: false,
            saving: false,
            questionModal: null,
            isEditingQuestion: false,
            editingQuestionId: null,
            questionForm: {
                question_title: '',
                answers: [
                    { answer_title: '', tempId: Date.now() },
                    { answer_title: '', tempId: Date.now() + 1 },
                    { answer_title: '', tempId: Date.now() + 2 },
                    { answer_title: '', tempId: Date.now() + 3 }
                ],
                correctAnswerIndex: 0,
                require: true
            },
            // Leaderboard data
            leaderboardData: [],
            leaderboardLoading: false,
            leaderboardLimit: 50,
            statistics: {
                total_participants: 0,
                average_score: 0,
                highest_score: 0,
                total_questions: 0
            }
        }
    },
    computed: {
        ...mapGetters('TriviaIndex', ['triviaitems', 'isTriviaNew', 'newTrivia']),
    },
    watch: {
        triviaitems: {
            handler(val) {
                if (val && !this.isTriviaNew) {
                    this.formData.title = val.title || '';
                    this.formData.timeLimit = val.time_limit || 30;
                    this.formData.isOpen = val.is_open || false;
                    this.statistics.total_questions = val.questions_detail?.length || 0;
                }
            },
            immediate: true,
            deep: true
        },
        
        isTriviaNew: {
            handler(val) {
                if (val) {
                    this.formData.title = '';
                    this.formData.timeLimit = 30;
                    this.formData.isOpen = false;
                    this.titleError = '';
                }
            },
            immediate: true
        }
    },
    created() {
        this.eventId = this.$route.params.event_id
        if (this.eventId) {
            this.fetchTriviaData(this.eventId);
        } else {
            console.error('No event ID found in route params');
        }
    },
    mounted() {
        this.questionModal = new Modal(document.getElementById('questionModal'));
    },
    beforeUnmount() {
        this.resetState();
        if (this.questionModal) {
            this.questionModal.dispose();
        }
        delete this.$flashMessage.groups.trivia_index;
    },
    methods: {
        ...mapActions('TriviaIndex', [
            'fetchTriviaData',
            'storeTriviaData',
            'updateTriviaData',
            'destroyTriviaData',
            'resetState',
            'setNewTrivia'
        ]),
        
        ...mapActions('TriviaSingle', ['resetState as resetSingleState']),

        updateIsOpen(e) {
            this.formData.isOpen = e.target.checked;
        },

        validateTitle() {
            if (!this.formData.title || this.formData.title.trim() === '') {
                this.titleError = 'Trivia title is required';
                return false;
            }
            this.titleError = '';
            return true;
        },

        async createTrivia() {
            if (!this.validateTitle()) {
                this.$flashMessage.show({
                    id: uuidv4(),
                    group: 'trivia_index',
                    type: 'error',
                    title: 'Validation Error',
                    time: 1000,
                    text: this.titleError
                });
                return;
            }

            this.loading = true;
            
            this.$store.commit('TriviaIndex/setTriviaTitle', this.formData.title);
            this.$store.commit('TriviaIndex/setTimeLimit', this.formData.timeLimit);
            this.$store.commit('TriviaIndex/setIs_open', this.formData.isOpen);
            
            this.storeTriviaData(this.eventId)
                .then(async (resp) => {
                    this.$flashMessage.show({
                        id: uuidv4(),
                        group: 'trivia_index',
                        type: 'success',
                        title: 'Success',
                        time: 800,
                        html: '<ul><li>Trivia created successfully.</li></ul>',
                    });
                    await this.fetchTriviaData(this.eventId);
                    this.activeTab = 'questions';
                })
                .catch(error => {
                    let html = gettingErrorMessage(error);
                    this.$flashMessage.show({
                        id: uuidv4(),
                        group: 'trivia_index',
                        type: 'error',
                        title: 'Failed',
                        time: 1000,
                        text: html || 'Something went wrong',
                        html: html
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        async updateTrivia() {
            if (!this.validateTitle()) {
                this.$flashMessage.show({
                    id: uuidv4(),
                    group: 'trivia_index',
                    type: 'error',
                    title: 'Validation Error',
                    time: 1000,
                    text: this.titleError
                });
                return;
            }

            this.loading = true;

            this.$store.commit('TriviaIndex/setTriviaTitle', this.formData.title);
            this.$store.commit('TriviaIndex/setTimeLimit', this.formData.timeLimit);
            this.$store.commit('TriviaIndex/setIs_open', this.formData.isOpen);

            await this.updateTriviaData({
                trivia_id: this.triviaitems._id
            }).then(async () => {
                this.$flashMessage.show({
                    id: uuidv4(),
                    group: 'trivia_index',
                    type: 'success',
                    title: 'Success',
                    time: 800,
                    html: '<ul><li>Trivia updated successfully.</li></ul>',
                });
                await this.fetchTriviaData(this.eventId);
            }).catch(error => {
                let html = gettingErrorMessage(error);
                this.$flashMessage.show({
                    id: uuidv4(),
                    group: 'trivia_index',
                    type: 'error',
                    title: 'Failed',
                    text: html || 'Something went wrong',
                    html: html
                });
            }).finally(() => {
                this.loading = false;
            });
        },

        deleteTrivia() {
            this.$swal({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "Delete",
                confirmButtonColor: "#dd4b39",
                focusCancel: true,
                reverseButtons: true
            }).then(result => {
                if (result.isConfirmed) {
                    this.destroyTriviaData(this.triviaitems._id).then(() => {
                        this.$flashMessage.show({
                            group: 'trivia_index',
                            type: 'success',
                            title: 'Success',
                            time: 1000,
                            html: '<ul><li>Trivia has been deleted successfully.</li></ul>'
                        });
                        this.fetchTriviaData(this.eventId);
                        this.activeTab = 'setup';
                        this.formData.title = '';
                        this.formData.timeLimit = 30;
                        this.formData.isOpen = false;
                        this.setNewTrivia(true);
                    });
                }
            });
        },

        createClick() {
            this.setNewTrivia(true);
            this.activeTab = 'setup';
            this.formData.title = '';
            this.formData.timeLimit = 30;
            this.formData.isOpen = false;
            this.titleError = '';
        },

        cancelClick() {
            this.setNewTrivia(false);
            this.fetchTriviaData(this.eventId);
        },

        openAddQuestionModal() {
            this.resetQuestionForm();
            this.isEditingQuestion = false;
            this.editingQuestionId = null;
            this.questionError = '';
            this.questionModal.show();
        },

        editQuestion(question) {
            console.log('Editing question:', question); // Debug log
    
            // Reset form first
            this.resetQuestionForm();
            
            // Set editing mode
            this.isEditingQuestion = true;
            this.editingQuestionId = question._id;
            
            // Set question title and require flag
            this.questionForm.question_title = question.question_title;
            this.questionForm.require = question.require;
            
            // Map answers with correct answer index
            this.questionForm.answers = question.answers.map((ans, idx) => ({
                answer_title: ans.answer_title,
                _id: ans._id,
                tempId: Date.now() + idx
            }));
            
            // Find the index of correct answer
            const correctIndex = question.answers.findIndex(ans => ans.is_correct === true);
            this.questionForm.correctAnswerIndex = correctIndex >= 0 ? correctIndex : 0;
            
            // Clear any previous errors
            this.questionError = '';
            
            // Show the modal
            this.questionModal.show();
            
            console.log('Question form after edit:', this.questionForm); // Debug log
        },

        resetQuestionForm() {
            this.questionForm = {
                question_title: '',
                answers: [
                        { answer_title: '', tempId: Date.now() },
                        { answer_title: '', tempId: Date.now() + 1 },
                        { answer_title: '', tempId: Date.now() + 2 },
                        { answer_title: '', tempId: Date.now() + 3 }
                    ],
                correctAnswerIndex: 0,
                require: true
            };
        },

        addAnswer() {
            if (this.questionForm.answers.length < 4) {
                this.questionForm.answers.push({
                    answer_title: '',
                    tempId: Date.now() + Math.random()
                });
            } else {
                this.$flashMessage.show({
                    group: 'trivia_index',
                    type: 'warning',
                    title: 'Limit Reached',
                    html: '<ul><li>Maximum 4 answer options allowed</li></ul>'
                });
            }
        },

        removeAnswer(index) {
            if (this.questionForm.answers.length > 2) {
                this.questionForm.answers.splice(index, 1);
                if (this.questionForm.correctAnswerIndex >= this.questionForm.answers.length) {
                    this.questionForm.correctAnswerIndex = this.questionForm.answers.length - 1;
                }
            }
        },

        validateQuestion() {
            if (!this.questionForm.question_title || this.questionForm.question_title.trim() === '') {
                this.questionError = 'Question is required';
                return false;
            }
            
            if (this.questionForm.answers.length < 4) {
                this.questionError = 'Please add at least 4 answer options';
                return false;
            }
            
            const allFilled = this.questionForm.answers.every(a => a.answer_title && a.answer_title.trim());
            if (!allFilled) {
                this.questionError = 'Please fill all answer options';
                return false;
            }
            
            this.questionError = '';
            return true;
        },

        async saveQuestion() {
            console.log('Saving question - isEditingQuestion:', this.isEditingQuestion); // Debug log
            console.log('Question data:', this.questionForm); // Debug log
            
            if (!this.validateQuestion()) {
                this.$flashMessage.show({
                    group: 'trivia_index',
                    type: 'error',
                    title: 'Validation Error',
                    html: '<ul><li>' + this.questionError + '</li></ul>'    
                });
                return;
            }

            this.saving = true;

            const answers = this.questionForm.answers.map((answer, idx) => ({
                answer_title: answer.answer_title.trim(),
                description: '',
                is_correct: idx === this.questionForm.correctAnswerIndex,
                ...(answer._id && { _id: answer._id })
            }));

            const questionData = {
                question_title: this.questionForm.question_title.trim(),
                question_type: 'radio',
                require: this.questionForm.require,
                answers: answers
            };

            try {
                const headers = {
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                };
                
                if (this.isEditingQuestion) {
                    // Update existing question
                    console.log('Updating question:', this.editingQuestionId);
                    await axios.patch(
                        `${constants.API_URL}/api/trivia/${this.triviaitems._id}/question/${this.editingQuestionId}`,
                        questionData,
                        { headers }
                    );
                    this.$flashMessage.show({
                        group: 'trivia_index',
                        type: 'success',
                        title: 'Success',
                        html: '<ul><li>Question updated successfully</li></ul>'
                    });
                } else {
                    // Create new question
                    console.log('Creating new question');
                    await axios.post(
                        `${constants.API_URL}/api/trivia/${this.triviaitems._id}/question`,
                        questionData,
                        { headers }
                    );
                    this.$flashMessage.show({
                        group: 'trivia_index',
                        type: 'success',
                        title: 'Success',
                        html: '<ul><li>Question added successfully</li></ul>'
                    });
                }
                
                // Refresh trivia data to show updated questions
                await this.fetchTriviaData(this.eventId);
                
                // Reset form and close modal
                this.resetQuestionForm();
                this.isEditingQuestion = false;
                this.editingQuestionId = null;
                this.questionModal.hide();
                
            } catch (error) {
                console.error('Error saving question:', error);
                this.$flashMessage.show({
                    group: 'trivia_index',
                    type: 'error',
                    title: 'Error',
                    html: '<ul><li>' + (error.response?.data?.message || 'Something went wrong') + '</li></ul>'
                });
            } finally {
                this.saving = false;
            }
        },

        async deleteQuestion(questionId) {
            this.$swal({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "Delete",
                confirmButtonColor: "#dd4b39",
                focusCancel: true,
                reverseButtons: true
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        const headers = {
                            'Authorization': 'Bearer ' + localStorage.getItem('token')
                        };
                        
                        await axios.delete(
                            `${constants.API_URL}/api/trivia/${this.triviaitems._id}/question/${questionId}`,
                            { headers }
                        );
                        
                        this.$flashMessage.show({
                            group: 'trivia_index',
                            type: 'success',
                            title: 'Success',
                            html: '<ul><li>Question deleted successfully</li></ul>'
                        });
                        
                        await this.fetchTriviaData(this.eventId);
                    } catch (error) {
                        console.error('Error deleting question:', error);
                        this.$flashMessage.show({
                            group: 'trivia_index',
                            type: 'error',
                            title: 'Error',
                            html: '<ul><li>' + (error.response?.data?.message || 'Failed to delete question') + '</li></ul>'
                        });
                    }
                }
            });
        },

        getCorrectAnswerText(question) {
            if (!question.answers) return 'N/A';
            const correct = question.answers.find(ans => ans.is_correct);
            return correct ? correct.answer_title : 'N/A';
        },

       async loadLeaderboard() {
            if (!this.triviaitems || !this.triviaitems._id) return;
            
            this.leaderboardLoading = true;
            try {
                const headers = {
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                };
                
                const response = await axios.get(
                    `${constants.API_URL}/api/trivia/${this.triviaitems._id}/leaderboard?limit=${this.leaderboardLimit}`,
                    { headers }
                );
                
                // Get total questions count from trivia
                const totalQuestions = this.triviaitems.questions_detail?.length || 0;
                
               this.leaderboardData = (response.data.data || []).map(score => {
                    // Normalize raw score: undefined, null, "" → 0
                    const rawScore = Number(score.score) || 0;

                    const totalQuestions = this.triviaitems.questions_detail?.length || 0;

                    // Calculate percentage
                    let percentageScore = rawScore;
                    if (rawScore <= totalQuestions && totalQuestions > 0) {
                        percentageScore = (rawScore / totalQuestions) * 100;
                    }

                    return {
                        ...score,
                        score: Math.round(percentageScore),   // Final percentage score
                        raw_score: rawScore,                  // Always a valid number
                        total_questions: totalQuestions,
                        correct_answers: rawScore             // rawScore is already correct answers
                    };
                });
                
                // Calculate statistics based on percentage scores
                if (this.leaderboardData.length > 0) {
                    const scores = this.leaderboardData.map(s => s.score);
                    this.statistics.total_participants = this.leaderboardData.length;
                    this.statistics.average_score = Math.round(scores.reduce((a, b) => a + b, 0) / scores.length);
                    this.statistics.highest_score = Math.max(...scores);
                }
                
                console.log('Leaderboard data with percentages:', this.leaderboardData); // Debug log
                
            } catch (error) {
                console.error('Error loading leaderboard:', error);
                this.$flashMessage.show({
                    group: 'trivia_index',
                    type: 'error',
                    title: 'Error',
                    html: '<ul><li>Failed to load leaderboard</li></ul>'
                });
            } finally {
                this.leaderboardLoading = false;
            }
        },

        getRankClass(index) {
            if (index === 0) return 'rank-1';
            if (index === 1) return 'rank-2';
            if (index === 2) return 'rank-3';
            return '';
        },

        getScoreClass(score) {
            if (score >= 80) return 'bg-success';
            if (score >= 60) return 'bg-info';
            if (score >= 40) return 'bg-warning';
            return 'bg-danger';
        },

        getAccuracyClass(accuracy) {
            if (accuracy >= 80) return 'bg-success';
            if (accuracy >= 60) return 'bg-info';
            if (accuracy >= 40) return 'bg-warning';
            return 'bg-danger';
        },

        formatDate(date) {
            if (!date) return 'N/A';
            const d = new Date(date);
            return d.toLocaleDateString() + ' ' + d.toLocaleTimeString();
        },

        exportLeaderboard() {
            if (!this.leaderboardData.length) {
                this.$flashMessage.show({
                    group: 'trivia_index',
                    type: 'warning',
                    title: 'No Data',
                    text: 'No leaderboard data to export'
                });
                return;
            }

            const headers = ['Rank', 'Participant Name', 'Email', 'Score (%)', 'Correct Answers', 'Total Questions', 'Accuracy (%)', 'Submitted At'];
            const rows = this.leaderboardData.map((score, index) => [
                index + 1,
                score.user_name || 'Anonymous',
                score.user_email || '',
                score.score,
                score.correct_answers || 0,
                score.total_questions || 0,
                score.accuracy || 0,
                this.formatDate(score.submitted_at)
            ]);

            const csvContent = [headers, ...rows].map(row => row.join(',')).join('\n');
            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', `leaderboard_${this.triviaitems.title}.csv`);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        resetFormAfterEdit() {
            this.isEditingQuestion = false;
            this.editingQuestionId = null;
            this.resetQuestionForm();
            this.questionError = '';
        }
    }
}
</script>

<style lang="scss" scoped>
.trivia-container {
    padding: 20px;
}

.card {
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    
    .card-header {
        background-color: #f8f9fa;
        border-bottom: 1px solid #dee2e6;
        
        h5 {
            margin: 0;
            font-weight: 600;
        }
    }
}

.answer-list {
    margin: 0;
    padding-left: 20px;
    
    li {
        font-size: 13px;
        margin: 2px 0;
    }
}

.answer-option {
    padding: 8px;
    background: #f8f9fa;
    border-radius: 4px;
    transition: all 0.2s;
    
    &:hover {
        background: #e9ecef;
    }
}

.table {
    margin-bottom: 0;
    
    th {
        font-weight: 600;
        background-color: #f8f9fa;
        border-bottom: 2px solid #dee2e6;
    }
    
    td {
        vertical-align: middle;
        
        &.question-text {
            max-width: 300px;
            word-wrap: break-word;
        }
    }
}

.badge {
    padding: 5px 10px;
    font-size: 12px;
}

.btn-sm {
    padding: 4px 8px;
}

.modal-lg {
    max-width: 800px;
}

.modal-body {
    max-height: 70vh;
    overflow-y: auto;
}

.input-group-text {
    min-width: 30px;
    justify-content: center;
}

.text-danger {
    font-size: 12px;
}

/* Leaderboard Styles */
.stat-card {
    transition: transform 0.2s;
    
    &:hover {
        transform: translateY(-5px);
    }
    
    .card-body {
        padding: 20px;
        
        i {
            opacity: 0.8;
        }
        
        h3 {
            margin: 10px 0;
            font-weight: bold;
        }
    }
}

.leaderboard-table {
    tbody tr {
        transition: background-color 0.2s;
        
        &:hover {
            background-color: #f8f9fa;
        }
        
        &.top-rank {
            background-color: #fff9e6;
        }
    }
    
    .rank-badge {
        display: inline-block;
        width: 40px;
        text-align: center;
        font-weight: bold;
        
        &.rank-1 {
            color: #ffd700;
            font-size: 1.2em;
        }
        
        &.rank-2 {
            color: #c0c0c0;
            font-size: 1.1em;
        }
        
        &.rank-3 {
            color: #cd7f32;
            font-size: 1em;
        }
    }
    
    .user-info {
        strong {
            font-size: 14px;
        }
        
        small {
            font-size: 11px;
        }
    }
    
    .score-bar {
        min-width: 120px;
        
        .progress {
            border-radius: 15px;
            overflow: hidden;
            
            .progress-bar {
                line-height: 30px;
                font-size: 12px;
                font-weight: bold;
                transition: width 0.5s ease;
            }
        }
    }
}

.nav-tabs {
    border-bottom: 2px solid #dee2e6;
    
    .nav-link {
        border: none;
        color: #6c757d;
        font-weight: 500;
        padding: 12px 20px;
        transition: all 0.3s;
        
        i {
            margin-right: 8px;
        }
        
        &:hover {
            color: #007bff;
            background: transparent;
        }
        
        &.active {
            color: #007bff;
            border-bottom: 2px solid #007bff;
            background: transparent;
        }
    }
}

.input-group-text.wrap-text {
    white-space: normal;
    word-break: break-word;
    overflow-wrap: break-word;
}

@media (max-width: 768px) {
    .table-responsive {
        font-size: 14px;
    }
    
    .answer-option .row > div {
        margin-bottom: 8px;
    }
    
    .stat-card {
        margin-bottom: 15px;
    }
    
    .nav-tabs .nav-link {
        padding: 8px 12px;
        font-size: 12px;
        
        i {
            margin-right: 4px;
        }
    }

}
</style>